import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "mb-6" }
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = { class: "flex justify-between items-center mb-2" }
const _hoisted_5 = { class: "relative group" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_8 = {
  key: 1,
  class: "flex items-center"
}
const _hoisted_9 = { key: 2 }
const _hoisted_10 = {
  key: 1,
  class: "absolute bottom-full mb-2 left-1/2 transform -translate-x-1/2 px-3 py-2 bg-gray-800 text-white text-xs rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap"
}
const _hoisted_11 = { class: "mb-6" }
const _hoisted_12 = {
  key: 0,
  class: "space-y-4"
}
const _hoisted_13 = { class: "text-xl font-bold" }
const _hoisted_14 = { class: "text-gray-600 mb-2" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  key: 1,
  class: "text-red-500"
}
const _hoisted_17 = { class: "w-full bg-gray-200 rounded-full h-2.5" }
const _hoisted_18 = {
  key: 1,
  class: "bg-gray-50 rounded-lg p-6 text-center border border-gray-200"
}
const _hoisted_19 = { class: "flex flex-col items-center" }
const _hoisted_20 = {
  key: 0,
  class: "mt-4 p-4 bg-blue-50 rounded-lg"
}
const _hoisted_21 = { class: "flex items-center" }
const _hoisted_22 = { class: "mr-2" }
const _hoisted_23 = {
  key: 0,
  class: "animate-spin h-4 w-4 text-blue-500",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_24 = {
  key: 1,
  class: "h-4 w-4 text-green-500",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_25 = {
  key: 2,
  class: "h-4 w-4 text-red-500",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_26 = { class: "grid grid-cols-1 lg:grid-cols-3 gap-6" }
const _hoisted_27 = { class: "lg:col-span-2" }
const _hoisted_28 = { class: "bg-white rounded-lg shadow-md overflow-hidden" }
const _hoisted_29 = { class: "lg:col-span-1" }
const _hoisted_30 = {
  key: 0,
  class: "fixed inset-0 bg-black/50 flex items-center justify-center z-50"
}
const _hoisted_31 = { class: "bg-white rounded-lg shadow-lg w-full max-w-md p-6 relative" }
const _hoisted_32 = { class: "mb-4" }
const _hoisted_33 = { class: "mb-6" }
const _hoisted_34 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_35 = { class: "flex justify-end space-x-3" }
const _hoisted_36 = ["disabled"]
const _hoisted_37 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_38 = { key: 1 }
const _hoisted_39 = {
  key: 1,
  class: "fixed inset-0 bg-black/50 flex items-center justify-center z-50"
}
const _hoisted_40 = { class: "bg-white rounded-lg shadow-lg w-full max-w-md p-6" }
const _hoisted_41 = { class: "flex justify-end space-x-3" }
const _hoisted_42 = ["disabled"]
const _hoisted_43 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_44 = { key: 1 }
const _hoisted_45 = {
  key: 2,
  class: "fixed inset-0 bg-black/50 flex items-center justify-center z-50"
}
const _hoisted_46 = { class: "bg-white rounded-lg shadow-lg w-full max-w-md p-6 relative" }
const _hoisted_47 = { class: "mb-4" }
const _hoisted_48 = { class: "mb-6" }
const _hoisted_49 = { class: "flex justify-end space-x-3" }
const _hoisted_50 = ["disabled"]
const _hoisted_51 = ["disabled"]
const _hoisted_52 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_53 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_JobStatusNotification = _resolveComponent("JobStatusNotification")!
  const _component_TaskView = _resolveComponent("TaskView")!
  const _component_ActivityFeed = _resolveComponent("ActivityFeed")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_JobStatusNotification, _mergeProps(_ctx.jobNotifications.import, { onRetry: _ctx.retryImportPbiData }), null, 16, ["onRetry"]),
          _createVNode(_component_JobStatusNotification, _mergeProps(_ctx.jobNotifications.plannerTemplate, { onRetry: _ctx.retryPrepareTemplate }), null, 16, ["onRetry"]),
          _createVNode(_component_JobStatusNotification, _mergeProps(_ctx.jobNotifications.aiTemplate, { onRetry: _ctx.retryPrepareAITemplate }), null, 16, ["onRetry"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_ctx.canTriggerForecast)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openNewForecastModal && _ctx.openNewForecastModal(...args))),
                class: "bg-primary text-white px-4 py-2 rounded-md hover:bg-primary/90 transition-colors"
              }, _cache[16] || (_cache[16] = [
                _createElementVNode("svg", {
                  class: "h-5 w-5 mr-2 inline",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M12 6v6m0 0v6m0-6h6m-6 0H6"
                  })
                ], -1),
                _createTextVNode(" New Forecast ")
              ])))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            (_ctx.canTriggerForecast)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.importPbiData && _ctx.importPbiData(...args))),
                  class: _normalizeClass(["bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition-colors", { 'opacity-50 cursor-not-allowed': _ctx.isImportLoading || _ctx.isAutomaticImportInProgress }]),
                  disabled: _ctx.isImportLoading || _ctx.isAutomaticImportInProgress
                }, [
                  (_ctx.isImportLoading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, _cache[17] || (_cache[17] = [
                        _createElementVNode("svg", {
                          class: "animate-spin -ml-1 mr-2 h-4 w-4 text-white",
                          xmlns: "http://www.w3.org/2000/svg",
                          fill: "none",
                          viewBox: "0 0 24 24"
                        }, [
                          _createElementVNode("circle", {
                            class: "opacity-25",
                            cx: "12",
                            cy: "12",
                            r: "10",
                            stroke: "currentColor",
                            "stroke-width": "4"
                          }),
                          _createElementVNode("path", {
                            class: "opacity-75",
                            fill: "currentColor",
                            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          })
                        ], -1),
                        _createTextVNode(" Importing PBI Data... ")
                      ])))
                    : (_ctx.isAutomaticImportInProgress)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, _cache[18] || (_cache[18] = [
                          _createElementVNode("svg", {
                            class: "animate-spin -ml-1 mr-2 h-4 w-4 text-white",
                            xmlns: "http://www.w3.org/2000/svg",
                            fill: "none",
                            viewBox: "0 0 24 24"
                          }, [
                            _createElementVNode("circle", {
                              class: "opacity-25",
                              cx: "12",
                              cy: "12",
                              r: "10",
                              stroke: "currentColor",
                              "stroke-width": "4"
                            }),
                            _createElementVNode("path", {
                              class: "opacity-75",
                              fill: "currentColor",
                              d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            })
                          ], -1),
                          _createTextVNode(" Automatic Import in Progress... ")
                        ])))
                      : (_openBlock(), _createElementBlock("span", _hoisted_9, _cache[19] || (_cache[19] = [
                          _createElementVNode("svg", {
                            class: "h-5 w-5 mr-2 inline",
                            fill: "none",
                            stroke: "currentColor",
                            viewBox: "0 0 24 24",
                            xmlns: "http://www.w3.org/2000/svg"
                          }, [
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d: "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
                            })
                          ], -1),
                          _createTextVNode(" Import PBI Data ")
                        ])))
                ], 10, _hoisted_6))
              : _createCommentVNode("", true),
            (_ctx.isAutomaticImportInProgress)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Automatic import is already in progress "))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        (_ctx.forecastingProcesses.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.forecastingProcesses, (process) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: process.id,
                  class: "bg-white rounded-lg shadow-md p-6"
                }, [
                  _createElementVNode("h2", _hoisted_13, _toDisplayString(process.name) + " Reporting Period", 1),
                  _createElementVNode("p", _hoisted_14, [
                    _createTextVNode(_toDisplayString(_ctx.formatDate(process.start_date)) + " - " + _toDisplayString(_ctx.formatDate(process.end_date)) + " ", 1),
                    (_ctx.getDaysRemaining(process.end_date) > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_15, " (" + _toDisplayString(_ctx.getDaysRemaining(process.end_date)) + " days remaining) ", 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_16, " (Overdue) "))
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", {
                      class: "bg-blue-600 h-2.5 rounded-full",
                      style: _normalizeStyle({ width: _ctx.getProgressPercentage(process.start_date, process.end_date) + '%' })
                    }, null, 4)
                  ])
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _cache[25] || (_cache[25] = _createElementVNode("div", { class: "mb-4 p-3 bg-gray-100 rounded-full" }, [
                  _createElementVNode("svg", {
                    class: "h-8 w-8 text-gray-400",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                    })
                  ])
                ], -1)),
                (_ctx.activeAutomaticProcesses.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _cache[23] || (_cache[23] = _createElementVNode("h3", { class: "text-lg font-medium mb-2" }, "Automatic Processes", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeAutomaticProcesses, (process) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: process.id,
                          class: "mb-2"
                        }, [
                          _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("div", _hoisted_22, [
                              (process.status === _ctx.JOB_STATUS.RUNNING || process.status === _ctx.JOB_STATUS.CREATED)
                                ? (_openBlock(), _createElementBlock("svg", _hoisted_23, _cache[20] || (_cache[20] = [
                                    _createElementVNode("circle", {
                                      class: "opacity-25",
                                      cx: "12",
                                      cy: "12",
                                      r: "10",
                                      stroke: "currentColor",
                                      "stroke-width": "4"
                                    }, null, -1),
                                    _createElementVNode("path", {
                                      class: "opacity-75",
                                      fill: "currentColor",
                                      d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                    }, null, -1)
                                  ])))
                                : (process.status === _ctx.JOB_STATUS.FINISHED)
                                  ? (_openBlock(), _createElementBlock("svg", _hoisted_24, _cache[21] || (_cache[21] = [
                                      _createElementVNode("path", {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "stroke-width": "2",
                                        d: "M5 13l4 4L19 7"
                                      }, null, -1)
                                    ])))
                                  : (process.status === _ctx.JOB_STATUS.FAILED)
                                    ? (_openBlock(), _createElementBlock("svg", _hoisted_25, _cache[22] || (_cache[22] = [
                                        _createElementVNode("path", {
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                          "stroke-width": "2",
                                          d: "M6 18L18 6M6 6l12 12"
                                        }, null, -1)
                                      ])))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("span", null, _toDisplayString(process.type === _ctx.JOB_TYPE.IMPORT_PBI_DATA ? 'Importing PBI Data' : 'Preparing Planner Template') + ": " + _toDisplayString(_ctx.formatJobStatus(process.status)), 1)
                          ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                _cache[26] || (_cache[26] = _createElementVNode("h3", { class: "text-lg font-medium text-gray-900 mb-2" }, "No Active Reporting Periods", -1)),
                _cache[27] || (_cache[27] = _createElementVNode("p", { class: "text-gray-500 mb-6" }, "Start a new forecast process to begin tracking reporting periods", -1)),
                (_ctx.canTriggerForecast)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openNewForecastModal && _ctx.openNewForecastModal(...args))),
                      class: "inline-flex items-center px-4 py-2 bg-primary text-white rounded-md hover:bg-primary/90 transition-colors"
                    }, _cache[24] || (_cache[24] = [
                      _createElementVNode("svg", {
                        class: "h-5 w-5 mr-2",
                        fill: "none",
                        stroke: "currentColor",
                        viewBox: "0 0 24 24",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M12 6v6m0 0v6m0-6h6m-6 0H6"
                        })
                      ], -1),
                      _createTextVNode(" Start New Forecast ")
                    ])))
                  : _createCommentVNode("", true)
              ])
            ]))
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _cache[28] || (_cache[28] = _createStaticVNode("<div class=\"p-4 border-b border-gray-200 flex justify-between items-center\"><div><h2 class=\"text-xl font-semibold\">Tasks</h2><p class=\"text-sm text-gray-500\">Manage and track reporting tasks</p></div><button class=\"p-2 rounded-md hover:bg-gray-100\"><svg class=\"h-5 w-5 text-gray-500\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M19 9l-7 7-7-7\"></path></svg></button></div>", 1)),
            _createVNode(_component_TaskView, {
              myTasks: _ctx.myTasks,
              allTasks: _ctx.openTasks,
              reminders: _ctx.reminders,
              overdueRemindersCount: _ctx.overdueRemindersCount,
              canViewReminders: _ctx.canViewReminders
            }, null, 8, ["myTasks", "allTasks", "reminders", "overdueRemindersCount", "canViewReminders"])
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createVNode(_component_ActivityFeed, { activities: _ctx.activities }, null, 8, ["activities"])
        ])
      ])
    ]),
    (_ctx.showForecastModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("button", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showForecastModal = false)),
              class: "absolute top-4 right-4 text-gray-500 hover:text-gray-700"
            }, _cache[29] || (_cache[29] = [
              _createElementVNode("span", { class: "text-xl" }, "×", -1)
            ])),
            _cache[35] || (_cache[35] = _createElementVNode("h2", { class: "text-xl font-bold mb-2" }, "Create New Reporting Period", -1)),
            _cache[36] || (_cache[36] = _createElementVNode("p", { class: "text-gray-600 mb-6" }, "Set up a new reporting period by providing a name and date range.", -1)),
            _createElementVNode("div", _hoisted_32, [
              _cache[30] || (_cache[30] = _createElementVNode("label", {
                for: "periodName",
                class: "block text-sm font-medium text-gray-700 mb-1"
              }, "Period Name", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "periodName",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.periodName) = $event)),
                placeholder: "e.g. Q3 2025",
                class: "w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
              }, null, 512), [
                [_vModelText, _ctx.periodName]
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _cache[33] || (_cache[33] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, "Date Range", -1)),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", null, [
                  _cache[31] || (_cache[31] = _createElementVNode("label", {
                    for: "startDate",
                    class: "block text-sm text-gray-700 mb-1"
                  }, "Start Date", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    id: "startDate",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.startDate) = $event)),
                    class: "w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                  }, null, 512), [
                    [_vModelText, _ctx.startDate]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[32] || (_cache[32] = _createElementVNode("label", {
                    for: "endDate",
                    class: "block text-sm text-gray-700 mb-1"
                  }, "End Date", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    id: "endDate",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.endDate) = $event)),
                    class: "w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                  }, null, 512), [
                    [_vModelText, _ctx.endDate]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("button", {
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showForecastModal = false)),
                class: "px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 transition-colors"
              }, " Cancel "),
              _createElementVNode("button", {
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.confirmCreateForecast && _ctx.confirmCreateForecast(...args))),
                class: "px-4 py-2 bg-blue-700 text-white rounded-md hover:bg-blue-800 transition-colors",
                disabled: _ctx.isLoading
              }, [
                (_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_37, _cache[34] || (_cache[34] = [
                      _createElementVNode("svg", {
                        class: "animate-spin -ml-1 mr-2 h-4 w-4 text-white",
                        xmlns: "http://www.w3.org/2000/svg",
                        fill: "none",
                        viewBox: "0 0 24 24"
                      }, [
                        _createElementVNode("circle", {
                          class: "opacity-25",
                          cx: "12",
                          cy: "12",
                          r: "10",
                          stroke: "currentColor",
                          "stroke-width": "4"
                        }),
                        _createElementVNode("path", {
                          class: "opacity-75",
                          fill: "currentColor",
                          d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        })
                      ], -1),
                      _createTextVNode(" Processing... ")
                    ])))
                  : (_openBlock(), _createElementBlock("span", _hoisted_38, "Create Period"))
              ], 8, _hoisted_36)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showConfirmDialog)
      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, [
            _cache[38] || (_cache[38] = _createElementVNode("h3", { class: "text-lg font-medium mb-3" }, "Confirm Forecast Creation", -1)),
            _cache[39] || (_cache[39] = _createElementVNode("p", { class: "text-gray-600 mb-6" }, "Are you sure you want to create a new forecasting process? This action cannot be undone.", -1)),
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("button", {
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showConfirmDialog = false)),
                class: "px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 transition-colors"
              }, " Cancel "),
              _createElementVNode("button", {
                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.startForecastProcess && _ctx.startForecastProcess(...args))),
                class: "px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors",
                disabled: _ctx.isLoading
              }, [
                (_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_43, _cache[37] || (_cache[37] = [
                      _createElementVNode("svg", {
                        class: "animate-spin -ml-1 mr-2 h-4 w-4 text-white",
                        xmlns: "http://www.w3.org/2000/svg",
                        fill: "none",
                        viewBox: "0 0 24 24"
                      }, [
                        _createElementVNode("circle", {
                          class: "opacity-25",
                          cx: "12",
                          cy: "12",
                          r: "10",
                          stroke: "currentColor",
                          "stroke-width": "4"
                        }),
                        _createElementVNode("path", {
                          class: "opacity-75",
                          fill: "currentColor",
                          d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        })
                      ], -1),
                      _createTextVNode(" Processing... ")
                    ])))
                  : (_openBlock(), _createElementBlock("span", _hoisted_44, "Yes, Create"))
              ], 8, _hoisted_42)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showPbiImportModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("button", {
              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showPbiImportModal = false)),
              class: "absolute top-4 right-4 text-gray-500 hover:text-gray-700"
            }, _cache[40] || (_cache[40] = [
              _createElementVNode("span", { class: "text-xl" }, "×", -1)
            ])),
            _cache[44] || (_cache[44] = _createElementVNode("h2", { class: "text-xl font-bold mb-2" }, "Import PBI Data", -1)),
            _cache[45] || (_cache[45] = _createElementVNode("p", { class: "text-gray-600 mb-4" }, "Enter the file paths for CSV files exported from Power BI.", -1)),
            _cache[46] || (_cache[46] = _createElementVNode("p", { class: "text-gray-500 text-sm mb-6" }, [
              _createTextVNode(" Files should be accessible on the server. At least one file path is required. "),
              _createElementVNode("br"),
              _createTextVNode("Example: "),
              _createElementVNode("code", null, "/path/to/exported/data.csv")
            ], -1)),
            _createElementVNode("div", _hoisted_47, [
              _cache[41] || (_cache[41] = _createElementVNode("label", {
                for: "revExpFile",
                class: "block text-sm font-medium text-gray-700 mb-1"
              }, "Revenue/Expense File Path", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "revExpFile",
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.revExpFilePath) = $event)),
                placeholder: "e.g. /path/to/revexp.csv",
                class: "w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
              }, null, 512), [
                [_vModelText, _ctx.revExpFilePath]
              ])
            ]),
            _createElementVNode("div", _hoisted_48, [
              _cache[42] || (_cache[42] = _createElementVNode("label", {
                for: "bazaPLFile",
                class: "block text-sm font-medium text-gray-700 mb-1"
              }, "Baza PL File Path", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "bazaPLFile",
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.bazaPLFilePath) = $event)),
                placeholder: "e.g. /path/to/bazapl.csv",
                class: "w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
              }, null, 512), [
                [_vModelText, _ctx.bazaPLFilePath]
              ])
            ]),
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("button", {
                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.showPbiImportModal = false)),
                class: _normalizeClass(["px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 transition-colors", { 'opacity-50': _ctx.isImportLoading }]),
                disabled: _ctx.isImportLoading
              }, " Cancel ", 10, _hoisted_50),
              _createElementVNode("button", {
                onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.confirmImportPbiData && _ctx.confirmImportPbiData(...args))),
                class: "px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors",
                disabled: _ctx.isImportLoading
              }, [
                (_ctx.isImportLoading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_52, _cache[43] || (_cache[43] = [
                      _createElementVNode("svg", {
                        class: "animate-spin -ml-1 mr-2 h-4 w-4 text-white",
                        xmlns: "http://www.w3.org/2000/svg",
                        fill: "none",
                        viewBox: "0 0 24 24"
                      }, [
                        _createElementVNode("circle", {
                          class: "opacity-25",
                          cx: "12",
                          cy: "12",
                          r: "10",
                          stroke: "currentColor",
                          "stroke-width": "4"
                        }),
                        _createElementVNode("path", {
                          class: "opacity-75",
                          fill: "currentColor",
                          d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        })
                      ], -1),
                      _createTextVNode(" Processing... ")
                    ])))
                  : (_openBlock(), _createElementBlock("span", _hoisted_53, "Import Data"))
              ], 8, _hoisted_51)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}